import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import React, { memo, useRef } from 'react';
import { FormattedMessage } from 'react-intl';

import FilterForm from '../../../forms/FilterForm/FilterForm';

const plainSx = { width: '100%', display: 'block' };

/**
 * @param {Object} props
 * @param {string} [props.rootClassName]
 * @param {string} [props.className]
 * @param {string} [props.plainClassName]
 * @param {string} props.id
 * @param {React.ReactNode} props.label
 * @param {React.ReactNode} props.children
 * @param {Object} [props.initialValues]
 * @param {boolean} [props.keepDirtyOnReinitialize]
 * @param {number} [props.contentPlacementOffset]
 * @param {Function} props.onSubmit
 * @param {Function} [props.onClear]
 */
const FilterPlainComponent = ({
  rootClassName = null,
  className = null,
  plainClassName = null,
  id,
  label,
  children,
  initialValues = null,
  keepDirtyOnReinitialize = false,
  contentPlacementOffset,
  onSubmit,
  onClear,
}) => {
  const filterContentRef = useRef(null);

  const handleChange = (values) => {
    onSubmit(values);
  };

  const handleClear = () => {
    if (onClear) {
      onClear();
    }
    onSubmit(null);
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          mt: 4,
          mb: 2,
        }}
      >
        <Typography mb={2} textAlign="center" variant="h5">
          {label}
        </Typography>
        <Button color="secondary" onClick={handleClear} sx={{ p: 0 }}>
          <FormattedMessage id="FilterPlain.clear" />
        </Button>
      </Box>
      <Box className={plainClassName} id={id} ref={filterContentRef} sx={plainSx}>
        <FilterForm
          contentPlacementOffset={contentPlacementOffset}
          id={`${id}.form`}
          initialValues={initialValues}
          keepDirtyOnReinitialize={keepDirtyOnReinitialize}
          liveEdit
          onChange={handleChange}
        >
          {children}
        </FilterForm>
      </Box>
    </Box>
  );
};

const FilterPlain = memo(FilterPlainComponent);

export default FilterPlain;
